import { render, staticRenderFns } from "./CmgPasswordResetRequestComplete.vue?vue&type=template&id=a24a699c&scoped=true&lang=pug"
import script from "./cmg-password-reset-request-complete.ts?vue&type=script&lang=ts&external"
export * from "./cmg-password-reset-request-complete.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgPasswordResetRequestComplete.vue?vue&type=style&index=0&id=a24a699c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24a699c",
  null
  
)

export default component.exports